import { useEffect, useState } from "react";

export function useCountryCode() {
    const [country, setCountry] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const fetchCountry = async () => {
            try {
                const res = await fetch("https://ipapi.co/json/");
                const data = await res.json();

                if (isMounted) {
                    setCountry(data.country || null);
                }
            } catch (err) {
                if (isMounted) {
                    setError(true);
                    setCountry(null);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        void fetchCountry();

        return () => {
            isMounted = false;
        };
    }, []);

    return { countryCode: country, loading, error };
}
